var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIt = function SvgIt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464 80H208V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v416c0 8.84 7.16 16 16 16h176c8.84 0 16-7.16 16-16v-16h208c8.84 0 16-7.16 16-16s-7.16-16-16-16h-50.88l-9.6-48H464c26.47 0 48-21.53 48-48V128c0-26.47-21.53-48-48-48M80 376c0-13.23 10.77-24 24-24s24 10.77 24 24-10.77 24-24 24-24-10.77-24-24m48-88H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h48c8.84 0 16 7.16 16 16s-7.16 16-16 16m-96-64v-32h144v32zm144-112v32H32v-32zm32 256h44.48l-9.6 48H208zm0-64V112h256c8.82 0 16 7.18 16 16v176z"
  })));
};
export default SvgIt;